<template>    
	<div class="m-mycombat-list">
		<h1 class="myConBotBeforeTit">往期竞猜结果</h1>
		<table class='table' v-if="betList && myUid">
			<thead>
				<tr>
					<th>日期</th>
					<th>押涨跌</th>
					<th>结果</th>
					<th>数额</th>
					<th>盈亏</th>
				</tr>
			</thead>
			<tbody class="ta-center">
				<tr v-for="(item,index) in list" :key="index">
					<td>{{item.transDate}}</td>
					<td><k-text :type="item.betType"/></td>
					<td><k-text :type="item.upDown" skin="1" /></td>
					<td><k-num :value="item.betNum*100" />金币</td>
					<td><k-num :value="item.rewardGold" :sign="true" /></td>
				</tr>
			</tbody>
		</table>
		<div class="ta-center">
			<van-loading v-if="loading" size="24px">加载中...</van-loading>
			<a v-else href="javascript:;" class=" cl-gray" @click="loadMore()">{{finished?'暂无更多数据':'点击加载更多'}}</a>
		</div>
	</div>
</template>
<script>
    import {mapActions, mapGetters} from 'vuex'
    import {forEach} from "../../../utils/base"
    export default {
        props : {
            /*list : {
                type: Array,
                default : null
            }*/
        },
        data() {
            return {
                list : [],
                finished: false,
                loading: false,
                error : false,
                beforeId : 0,
                pageNum : 50,
                loadingText : '加载更多'
            }
        },
        computed: {
            ...mapGetters(['myInfo','myUid','myNick','myLogo']),
            ...mapGetters('mybet', ['betList','recordInfo']),
        },
        methods:{
            ...mapActions("mybet", ["loadMyBetList"]),
            loadMore(){
              if(!this.finished){
                  this.load();
              }
            },
            async load (){
                let {myUid, beforeId, pageNum} = this;
                this.loading = true;
                await this.loadMyBetList({
                    uid : myUid,
                    start : 0,
                    pageNum : pageNum,
                    rewardFlag: 1,
                    beforeId : beforeId,
                    afterId : 0,
                }).then(R => {
                	if(R.list.length){
						forEach(R.list, (item) => {
							this.list.push(item);
						});
						this.beforeId = R.list[R.list.length-1].id || 0;
					}
                    if(R.list.length < pageNum){
                        this.finished = true;
                    }
                }).catch(err => {
                    this.error = true;
                    this.$toast(err.message || err.error_code)
                })
                this.loading = false;
            }
        },
        mounted() {
            setTimeout(()=>{
                this.load ();
            },500)
        }
    }
</script>